import { render } from "./ConfirmNewAccount.vue?vue&type=template&id=5c57a554&scoped=true"
import script from "./ConfirmNewAccount.vue?vue&type=script&lang=js"
export * from "./ConfirmNewAccount.vue?vue&type=script&lang=js"

import "./ConfirmNewAccount.vue?vue&type=style&index=0&id=5c57a554&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c57a554"]])

export default __exports__